import React from "react"
import { GetAllBatches } from "domain/useCase/Admin/CreateClass/GetAllBatches"
import { CreateClassRepositoryImpl } from "data/repository/Admin/CreateClassRepositoryImpl"
import { CreateClassAPIDataSourceImpl } from "data/API/Admin/CreateClassAPIDataSourceImpl"
import { GetProgressMeetFeedback } from "domain/useCase/Admin/ProgressMeeting/GetProgressMeetFeedback"
import { ProgressMeetingRepositoryImpl } from "data/repository/Admin/ProgressMeetingRepositoryImpl"
import ProgressMeetingAPIDataSourceImpl from "data/API/Admin/ProgressMeetingAPIDataSourceImpl"
import { useAuth } from "core/context/auth"

export default function ProgressMeetingFeedbackViewModel() {
  const { auth } = useAuth()
  const [selectedPageTab, setSelectedPageTab] = React.useState("NPS")
  const [selectedTab, setSelectedTab] = React.useState<string>("All Students")
  const [minRating, setMinRating] = React.useState(1)
  const [maxRating, setMaxRating] = React.useState(10)
  const [batch, setBatch] = React.useState<any>([])
  const [studentBatch, setStudentBatch] = React.useState("")
  const [progressMeetFeedback, setProgressMeetFeedback] = React.useState([])
  const [filteredFeedback, setFilteredFeedback] = React.useState<any[]>([])
  const [fromDate, setFromDate] = React.useState<any>(null)
  const [toDate, setToDate] = React.useState<any>(null)
  const [searchByEmail, setSearchByEmail] = React.useState("")

  const getAllBatchesUseCase = new GetAllBatches(new CreateClassRepositoryImpl(new CreateClassAPIDataSourceImpl()))
  const getProgresMeetFeedbackUseCase = new GetProgressMeetFeedback(
    new ProgressMeetingRepositoryImpl(new ProgressMeetingAPIDataSourceImpl())
  )

  async function getBatches() {
    const response = await getAllBatchesUseCase.invoke(auth)
    if (response.success) {
      setBatch(response.data)
    }
  }

  async function getProgressMeetFeedback(meeting_id: string) {
    const response = await getProgresMeetFeedbackUseCase.invoke(auth, meeting_id)
    if (response) {
      setProgressMeetFeedback(response)
    }
  }
  function handleBatchChange(e: any) {
    if (e.target.value === "Select Batch") {
      setStudentBatch("")
    } else setStudentBatch(e.target.value)
  }

  function handleChange(e: any) {
    if (e.target.value) setSearchByEmail(e.target.value)
    else setSearchByEmail("")
  }

  const handlePageTabClick = (item: string) => {
    setSelectedPageTab(item)
  }
  const handleTabClick = (tab: string) => {
    setSelectedTab(tab)
    if (tab === "Less Than or Equal to 6") {
      setMinRating(1)
      setMaxRating(6)
    } else if (tab === "7-8 Rating") {
      setMinRating(7)
      setMaxRating(8)
    } else if (tab === "9-10 Rating") {
      setMinRating(9)
      setMaxRating(10)
    } else if (tab === "All Students") {
      setMinRating(1)
      setMaxRating(10)
    }
  }

  const feedbackKeys: { [key: string]: string } = {
    NPS: "recommendation_score",
    "LIVE CLASSES": "live_classes_feedback",
    EXAMS: "exams_feedback",
    MENTORSHIP: "mentorship_session_feedback",
    CONTENT: "content_quality_feedback",
    "DOUBT SUPPORT": "doubt_support_feedback",
  }

  const filterFeedback = (
    feedbackList: any[],
    selectedItem: string,
    selectedRating: string,
    email?: string,
    batch?: string,
    fromDate?: number | null,
    toDate?: number | null
  ) => {
    if (!selectedItem || !selectedRating) return feedbackList

    const feedbackKey = feedbackKeys[selectedItem]

    return feedbackList
      .filter((f) => {
        const rating = f[feedbackKey]

        // Apply rating filter
        if (selectedRating === "Less Than or Equal to 6") return rating <= 6
        if (selectedRating === "7-8 Rating") return rating >= 7 && rating <= 8
        if (selectedRating === "9-10 Rating") return rating >= 9

        return true
      })
      .filter((f) => {
        if (email && !f.email.includes(email)) return false

        if (batch && f.batch !== batch) return false

        if (fromDate && toDate) {
          const tfromDate = new Date(fromDate * 1000)
          const ttoDate = new Date(toDate * 1000)
          const feedbackDate = new Date(f.timestamp)
          return feedbackDate >= tfromDate && feedbackDate <= ttoDate
        }

        return true
      })
  }

  const handleSearch = () => {
    const filteredData = filterFeedback(
      progressMeetFeedback,
      selectedPageTab,
      selectedTab,
      searchByEmail,
      studentBatch,
      fromDate,
      toDate
    )
    setFilteredFeedback(filteredData)
  }

  React.useEffect(() => {
    const filteredData = filterFeedback(progressMeetFeedback, selectedPageTab, selectedTab)
    setFilteredFeedback(filteredData)
  }, [progressMeetFeedback, selectedPageTab, selectedTab])

  function handleDateChange(e: React.ChangeEvent<HTMLInputElement>) {
    const dateValue = e.target.value
    const timestamp = dateValue ? new Date(dateValue).getTime() / 1000 : null

    if (e.target.id === "fromDate") {
      setFromDate(timestamp)
    } else if (e.target.id === "toDate") {
      setToDate(timestamp)
    }
  }

  return {
    selectedPageTab,
    setSelectedPageTab,
    handlePageTabClick,
    selectedTab,
    setSelectedTab,
    handleTabClick,
    batch,
    setBatch,
    getBatches,
    handleBatchChange,
    studentBatch,
    getProgressMeetFeedback,
    setProgressMeetFeedback,
    progressMeetFeedback,
    filteredFeedback,
    feedbackKeys,
    fromDate,
    toDate,
    handleDateChange,
    searchByEmail,
    handleChange,
    handleSearch,
  }
}
